import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-what-we-do',
    templateUrl: './what-we-do.component.html',
    styleUrls: ['./what-we-do.component.scss']
})
export class WhatWeDoComponent implements OnInit {
    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Mit teszünk?'});
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/what-we-do.component.ts